import { deleteCookie, fetchWrapper, setCookie } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'auth';

export async function login(form) {
  const url = `${baseUrl}/login`;
  const session = await fetchWrapper.post(url, form);
  setCookie(process.env.REACT_APP_SESSION_NAME, session?.user?.token || '', 1);
  return session;
}

export async function logout() {
  removeSession();
}

export function removeSession() {
  deleteCookie(process.env.REACT_APP_SESSION_NAME);
  window.location.replace(process.env.REACT_APP_BASENAME || '/');
}

export async function getProfile() {
  return await fetchWrapper.get(`${baseUrl}/get/profile`);
}

export async function register(form) {
  const session = await fetchWrapper.post(`${baseUrl}/register`, form);
  setCookie(process.env.REACT_APP_SESSION_NAME, session?.user?.token || '', 1);
  return session;
}

export async function recover(form) {
  return await fetchWrapper.post(`${baseUrl}/recover`, form);
}

export async function updateProfile(form) {
  return await fetchWrapper.post(`${baseUrl}/profile`, form);
}

export async function updatePassword(form) {
  return await fetchWrapper.post(`${baseUrl}/profile/password`, form);
}

export async function uploadDniFiles(form) {
  return await fetchWrapper.post(`${baseUrl}/profile/dni`, form);
}

export async function checkGoogle(form) {
  const session = await fetchWrapper.post(`${baseUrl}/check-google`, form);
  if (session?.user?.token) {
    setCookie(process.env.REACT_APP_SESSION_NAME, session?.user?.token || '', 1);
  }
  return session;
}

export async function sendSupportComment(form) {
  return await fetchWrapper.post(`${baseUrl}/send-support-comment`, form);
}